<script></script>

<section id="the_nft">
  <div>
    <h2>THE NFT</h2>
    <p>
      This NFT was created by 2 Front-end development and Design students who
      were bored and wanted to make some cool art to pay off their student loan
      debts.
    </p>
    <br />
    <p>
      All of the assets are hand draw. The NFT’s are randomly generated so every
      icy penguin is a unique version.
    </p>
    <br />
    <p>Be quick, be cool, be icy.</p>
  </div>
  <div>
    <img src="images/12.png" alt="icy penguin 12" class="penguin" />
  </div>
</section>

<style>
  section {
    display: flex;
  }

  h2 {
    font-size: 1.5rem;
    font-style: italic;
    margin-bottom: 1em;
  }

  div:nth-child(1) {
    flex: 1;
    text-align: left;
    padding: 2em 0;
  }

  div:nth-child(2) {
    display: flex;
    justify-content: flex-end;
    flex: 1;
  }

  div > img {
    width: 75%;
    border-radius: 0.5rem;
    image-rendering: pixelated;
  }

  @media (max-width: 768px) {
    section {
      flex-direction: column;
    }

    div:nth-child(2) {
        justify-content: center;
        align-items: center;
        padding-bottom: 2em;
    }

    div > img {
        width: 100%;
    }
  }
</style>
